import { useSelector } from "react-redux";
export default () => {
    const globalStore = useSelector((state) => state.globalStore);
    return globalStore;
};
//# sourceMappingURL=useGlobalStoreState.js.map